module.exports = __webpack_public_path__ + "img/Structures-4.d656d9f3.png";